import React, { useState } from "react";

function Login({
  setIsShowAuthForm,
  setResponse,
  setSignUpProcessing,
  setIsSignedIn,
}) {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    setResponse("");
    if (email === "" || password === "") {
      setResponse("Fields cannot be empty, try again.");
      return;
    }
    setSignUpProcessing(true);
    fetch("https://ferry-backend.vercel.app/api/login", {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then((res) => {
        if (res.ok) {
          setSignUpProcessing(false);
          setResponse("Login successful!");
          setTimeout(() => {
            setIsShowAuthForm(false);
            document.getElementById("app-root").style.filter = "none";
          }, 2000);
        }
        if (res.status === 401) {
          setSignUpProcessing(false);
        }
        return res.json();
      })
      .then((data) => {
        if (data.status === "ok") {
          window.localStorage.setItem("token", data.data);
          setIsSignedIn(true);
        }
        if (data.error) {
          setSignUpProcessing(false);
          setResponse(data.error);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label>Email</label>
        <input
          type="email"
          className="form-control"
          placeholder="Enter email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <br />

      <div className="mb-3">
        <label>Password</label>
        <input
          type="password"
          className="form-control"
          placeholder="Enter password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <br />
      <div className="d-grid">
        <button type="submit" className="login-btn">
          SIGN IN
        </button>
      </div>
    </form>
  );
}

export default Login;
